// Persist stable codes; labels can change without migrating collections.
export const INDUSTRY_OPTIONS = Object.freeze([
  { value: "education", label: "Education" },
]);

export const INDUSTRY_CODES = Object.freeze(INDUSTRY_OPTIONS.map(option => option.value));
